import { useMutation } from '@tanstack/react-query'

import { marketShopAPI } from '@/api/new-api'
import { MarketShopOrderModel } from '@/models'

interface UpdateMarketShopRestaurantOrdersRequest {
  id: MarketShopOrderModel['id']
  status: MarketShopOrderModel['status']
}

export const updateMarketShopRestaurantOrderStatus = async ({
  id,
  ...rest
}: UpdateMarketShopRestaurantOrdersRequest) => {
  const response = await marketShopAPI.put<MarketShopOrderModel>(`/market-shop/order/${id}`, rest)
  return response.data
}

export const useUpdateMarketShopRestaurantOrderStatus = () => {
  return useMutation({
    mutationFn: updateMarketShopRestaurantOrderStatus,
  })
}
